var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4836 14.7122C33.098 15.3265 33.1419 16.2954 32.6153 16.9604L32.4836 17.1082L18.1077 31.4841C17.4933 32.0985 16.5245 32.1424 15.8594 31.6158L15.7117 31.4841L8.52368 24.2961C7.86204 23.6345 7.86204 22.5618 8.52368 21.9001C9.13806 21.2858 10.1069 21.2419 10.7719 21.7685L10.9197 21.9001L16.9105 27.8893L30.0876 14.7122C30.702 14.0978 31.6709 14.0539 32.3359 14.5805L32.4836 14.7122Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.b78b1cf9112a8f7384d3fe6c780abb02.svg";
export { ForwardRef as ReactComponent };